import {IonItem, IonLabel, IonList} from "@ionic/react";
import styles from "./styles.module.scss";
import {formatLongDate} from "../../../../utils/helpers/date";
import React from "react";

export const NotificationListView = ({
                                       notifications,
                                       selectNotification,
                                     }) => {

  return (
    <IonList>
      {
        notifications?.map((notification) => {
          return (
            <IonItem
              key={notification.notification_id}
              onClick={() => selectNotification(notification?.notification_id)}
              className={notification.read ? styles.read : styles.unread}
            >
              <IonLabel className="ion-text-wrap">
                <h3>{notification?.notification_title}</h3>
                <p>{formatLongDate(notification?.date)}</p>
              </IonLabel>
            </IonItem>
          )
        })
      }
    </IonList>
  )
}